import { RouteObject } from 'react-router-dom';
import ErrorPage, { Page404 } from 'src/error-page';
import findsRoutes from './finds/routes';
import notificationsRoutes from '../notifications/routes';
import { FaqPageType } from '../faq/types';
import EmailVerificationGuard from '../onboarding/verify-email/verify-email-guard';
import { lazyConReintento } from 'src/config/lazy-con-reintento';
import { diferida } from 'src/config/pagina-diferida';

const EnterpriseAccountConfig = lazyConReintento(() => import('./account-config'));
const FeedbackView = lazyConReintento(() => import('./feedback'));
const EnterpriseLayoutComponent = lazyConReintento(() => import('./layout/layout'));
const ManageView = lazyConReintento(() => import('./manage'));
const EnterpriseProfileView = lazyConReintento(() => import('./profile'));
const FaqPage = lazyConReintento(() => import('../faq/faq-page'));
const Index = lazyConReintento(() => import('./dashboard'));

// Las cuatro vistas de shortlist se exportan con nombre, no por defecto: `lazy` solo entiende
// `{ default }`, asi que hay que reenvasarlas.
const DraftShortlistPublicView = lazyConReintento(() => import('./draft-shortlist').then((m) => ({ default: m.DraftShortlistPublicView })));
const DraftShortlistDemoView = lazyConReintento(() => import('./draft-shortlist/demo').then((m) => ({ default: m.DraftShortlistDemoView })));
const ShortlistDemoGenerateView = lazyConReintento(() =>
  import('./draft-shortlist/demo/generate-view').then((m) => ({ default: m.ShortlistDemoGenerateView }))
);
const ShortlistDemoContactView = lazyConReintento(() =>
  import('./draft-shortlist/demo/contact-view').then((m) => ({ default: m.ShortlistDemoContactView }))
);

const enterpriseProfileRoutes: RouteObject[] = [
  {
    path: '/shortlists/demo',
    element: diferida(<DraftShortlistDemoView />),
    errorElement: <ErrorPage />
  },
  {
    path: '/shortlists/demo/contact',
    element: diferida(<ShortlistDemoContactView />),
    errorElement: <ErrorPage />
  },
  {
    path: '/shortlists/demo/generate',
    element: diferida(<ShortlistDemoGenerateView />),
    errorElement: <ErrorPage />
  },
  {
    path: '/shortlists/:id',
    element: diferida(<DraftShortlistPublicView />),
    errorElement: <ErrorPage />
  },
  {
    path: '/enterprises',
    element: diferida(
      <EmailVerificationGuard mode="require">
        <EnterpriseLayoutComponent />
      </EmailVerificationGuard>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Page404 />
      },
      {
        path: 'dashboard',
        element: diferida(<Index />)
      },
      {
        path: 'profile',
        element: diferida(<EnterpriseProfileView />)
      },
      {
        path: 'account-config',
        element: diferida(<EnterpriseAccountConfig />)
      },
      ...findsRoutes,
      {
        path: 'manage',
        element: diferida(<ManageView />)
      },
      {
        path: 'feedback',
        element: diferida(<FeedbackView />)
      },
      ...notificationsRoutes,
      {
        path: 'faq',
        element: diferida(<FaqPage type={FaqPageType.EnterpriseUser} />)
      },
      {
        path: '*',
        element: <Page404 />
      }
    ]
  }
];

export default enterpriseProfileRoutes;
